import { createAction, handleActions } from 'redux-actions';
import * as R from 'ramda';

export const types = {
  settingsSaveBackup: 'SETTINGS_SAVE_BACKUP',
  settingsRestoreBackup: 'SETTINGS_RESTORE_BACKUP',
  settingsBackupSaved: 'SETTINGS_BACKUP_SAVED',
  settingsBackupNextStep: 'SETTINGS_BACKUP_NEXT_STEP',
  settingsBackupRestored: 'SETTINGS_BACKUP_RESTORED',
  settingsRestoreNextStep: 'SETTINGS_RESTORE_NEXT_STEP',
  settingsSetAppSettings: 'SETTINGS_SET_APP_SETTINGS',
  settingsHandleForm: 'SETTINGS_HANDLE_FORM',
  settingsSaved: 'SETTINGS_SAVED',
};

export const settingsSaveBackup = createAction(types.settingsSaveBackup);
export const settingsRestoreBackup = createAction(types.settingsRestoreBackup);
export const settingsBackupSaved = createAction(types.settingsBackupSaved);
export const settingsBackupNextStep = createAction(types.settingsBackupNextStep);
export const settingsBackupRestored = createAction(types.settingsBackupRestored);
export const settingsRestoreNextStep = createAction(types.settingsRestoreNextStep);
export const settingsSetAppSettings = createAction(types.settingsSetAppSettings);
export const settingsHandleForm = createAction(types.settingsHandleForm);
export const settingsSaved = createAction(types.settingsSaved);

export const INITIAL_STATE = {
  saving: false,
  savingBackup: false,
  backupStep: 1,
  restoringBackup: false,
  restoreStep: 1,
  appSettings: {
    driller_name: '',
    driller_email: '',
    driller_email_message: '',
    driller_cc: '',
    default_hand: 'right_hander',
    default_ball_grip: 'finger_tip',
    default_thm_type: 'Oval',
    spec_sheet_auto_thumb_pitches: false,
    spec_sheet_auto_lateral_pitches: false,
    spec_sheet_auto_lateral_pitches_clt: false,
    spec_sheet_auto_insert_od: false,
    spec_sheet_auto_fill_bridge: false,
    spec_sheet_auto_repeat_insert_type: false,
    spec_sheet_auto_repeat_insert_size: false,
    pitch_added_to_oval_calculation: false,
    oval_machine_forward_thumb_positive: true,
    oval_machine_right_positive: true,
    pitch_center_edge: 'edge',
    display_measurement: 'fraction',
    span_measurement: '32',
    pitch_measurement: '32',
    oval_calculation: 'trigonometry',
    arsenal_layout_style: 'none',
    customize_list: {
      insert_type: [],
      thumb_insert_type: [],
      ball_manufacturer: [],
    },
    proshop_name: '',
    owner_firstname: '',
    owner_lastname: '',
    owner_email: '',
    owner_password: '',
    owner_password_verification: '',
  },
};

export const settingsReducer = handleActions(
  {
    [types.settingsSaveBackup]: state => ({
      ...state,
      savingBackup: true,
    }),
    [types.settingsRestoreBackup]: state => ({
      ...state,
      restoringBackup: true,
    }),
    [types.settingsBackupSaved]: state => ({
      ...state,
      savingBackup: false,
      backupStep: 1,
    }),
    [types.settingsBackupNextStep]: state => ({
      ...state,
      backupStep: state.backupStep + 1,
    }),
    [types.settingsBackupRestored]: state => ({
      ...state,
      restoringBackup: false,
      restoreStep: 1,
    }),
    [types.settingsRestoreNextStep]: state => ({
      ...state,
      restoreStep: state.restoreStep + 1,
    }),
    [types.settingsHandleForm]: state => ({
      ...state,
      saving: true,
    }),
    [types.settingsSetAppSettings]: (state, action) => ({
      ...state,
      appSettings: R.merge(state.appSettings)(action.payload.appSettings),
    }),
    [types.settingsSaved]: state => ({
      ...state,
      saving: false,
    }),
  },
  INITIAL_STATE
);
